export const internalDavidBoehmer = {
  id: '6b75d444-c10f-4582-9813-ca7f7d753bed',
  name: 'David Boehmer',
};

export const internalMaxRavesh = {
  id: 'a52dc7c7-2d53-4533-8e63-ab9916f9b666',
  name: 'Max Ravech',
};

export const internalAmandaChi = {
  id: '00344e02-2d2c-40d3-80ff-ecd13f3ffd00',
  name: 'Amanda Chi',
};

export const internalKaylaKanipe = {
  id: '18749210-7e48-4684-8028-481df8c22611',
  name: 'Kayla Kanipe',
};

export const internalClareBuxton = {
  id: 'bf1f8ca0-3bfb-4688-954f-f8966c8f1885',
  name: 'Clare Buxton',
};

export const internalOliviaBarthDeNavi = {
  id: 'ec1968b3-4c84-4959-9bb4-1bf1c32d8d5a',
  name: 'Olivia Barth DeNavi',
};

export const internalSamLassoff = {
  id: '6bf3fa80-41ea-4b9a-812c-c605acc0ceb3',
  name: 'Sam Lassoff',
};

export const internalLilyTympanick = {
  id: 'fc25b896-0592-4876-9715-c3c7f4da63c7',
  name: 'Lily Tympanick',
};

export const internalLizKase = {
  id: '4a5da129-119a-4922-a0d4-fb97f0a38661',
  name: 'Liz Kase',
};

export const internalLaurenMello = {
  id: '6111ec30-a2b0-42fd-8917-73289e8b61ed',
  name: 'Lauren Mello',
};

// hard-coded advisors until we have an endpoint to return only these people
// we currently return everyone with admin role which is way more people
export const internalAdvisors = [
  {
    label: internalDavidBoehmer.name,
    value: internalDavidBoehmer.id,
  },
  {
    label: internalKaylaKanipe.name,
    value: internalKaylaKanipe.id,
  },

  {
    label: internalOliviaBarthDeNavi.name,
    value: internalOliviaBarthDeNavi.id,
  },

  { label: internalClareBuxton.name, value: internalClareBuxton.id },

  { label: internalLizKase.name, value: internalLizKase.id },

  { label: internalLaurenMello.name, value: internalLaurenMello.id },
];

export const internalCustomerSuccess = [
  {
    label: internalAmandaChi.name,
    value: internalAmandaChi.id,
  },
  {
    label: internalClareBuxton.name,
    value: internalClareBuxton.id,
  },
  { label: internalDavidBoehmer.name, value: internalDavidBoehmer.id },
  {
    label: internalKaylaKanipe.name,
    value: internalKaylaKanipe.id,
  },
  {
    label: internalLaurenMello.name,
    value: internalLaurenMello.id,
  },
  {
    label: internalLilyTympanick.name,
    value: internalLilyTympanick.id,
  },
  {
    label: internalLizKase.name,
    value: internalLizKase.id,
  },
  {
    label: internalMaxRavesh.name,
    value: internalMaxRavesh.id,
  },
  {
    label: internalOliviaBarthDeNavi.name,
    value: internalOliviaBarthDeNavi.id,
  },
  {
    label: internalSamLassoff.name,
    value: internalSamLassoff.id,
  },
];

/**
 * Team members who have left Banff. They stay in `internalCustomerSuccess`
 * so their existing assignments keep resolving in displays and filters, but
 * new-assignment pickers must not offer them.
 */
const departedInternalIds: string[] = [internalSamLassoff.id];

/** `internalCustomerSuccess` minus departed members — for new-assignment pickers. */
export const internalCustomerSuccessAssignable = internalCustomerSuccess.filter(
  (person) => !departedInternalIds.includes(person.value),
);
